<h4 class="text-center" *ngIf="playList">{{ playList.title }}</h4>
<table class="table table-striped" *ngIf="playList">
  <thead>
    <tr>
      <th scope="col">#</th>
      <th scope="col">{{ 'common.label.title' | translate }}</th>
      <th scope="col">{{ 'feature.song.release_date' | translate }}</th>
      <th scope="col"></th>
    </tr>
  </thead>
  <tbody>
    <tr
      [routerLink]="['/song','detail']"
      [queryParams]="{id: song.id}"
      *ngFor="let song of songPage.content | likes:'SONG':(currentUser$ | async); index as i"
    >
      <th scope="row">{{ song.rn }}</th>
      <td><a [routerLink]="['/song','detail']" [queryParams]="{id: song.id}">{{ song.title }}</a></td>
      <td>{{ song.releaseDate | date: 'dd/MM/yyyy' }}</td>
      <td>
        <app-song-like-btn [song]="song"></app-song-like-btn>
        <app-song-menu-btn [song]="song"></app-song-menu-btn>
        <button class="btn btn-sm btn-danger rounded-pill mx-2" (click)="openDeleteDialog(playList, song, $event)">
          <i class="bi bi-trash"></i>
        </button>
      </td>
    </tr>
  </tbody>
</table>
<ngb-pagination
  *ngIf="songPage.totalPages > 1"
  [collectionSize]="songPage.totalElements"
  [page]="songPage.pageable?.pageNumber + 1"
  [pageSize]="songPage.pageable?.pageSize"
  (pageChange)="getSongPage($event - 1)"
></ngb-pagination>
